<template>
  <el-dialog :visible.sync="shouldShow" @close="closeEvent" width="45%">
    <template slot="title">
      <h5 class="title">Verification for {{ titleize(identityType) }}</h5>
    </template>
    <div class="data-headers">
      <div
        v-for="(dh, index) in dataHeaders"
        :key="index"
        :class="
          typeof verification[dh] === 'string'
            ? 'data-min-header'
            : 'data-header'
        "
      >
        <h6 :md="10">{{ titleize(dh) }}</h6>
        <template v-if="typeof verification[dh] === 'string'">
          <div class="data-header--content">
            <span>{{ verification[dh] }}</span>
          </div>
        </template>

        <el-row v-else type="flex" :gutter="10" class="flex-wrap">
          <template v-for="(dk, key) in verification[dh]">
            <el-col
              v-if="key === 'image' || key === 'signature'"
              :span="24"
              :key="key"
            >
              <div v-if="key === 'image'" :class="`data-header--image__${key}`">
                <img
                  :src="dk ? getBase64Image(dk) : getImage('no-user.png')"
                  :alt="key"
                  width="100"
                  @error="$event.target.src = `${getImage('no-user.png')}`"
                  height="100"
                />
              </div>
            </el-col>
            <el-col v-else :md="12" :lg="12" :key="key" type="flex">
              <div class="data-header--content">
                <span>{{ titleize(key) }}:</span>
                <template v-if="typeof dk === 'object'">
                  <p v-for="(innerVal, innerKey) in dk" :key="innerKey">
                    <span>{{ titleize(innerKey) }}:</span>
                    <span class="text-right"
                      ><strong>{{ innerVal }}</strong></span
                    >
                  </p>
                </template>
                <p v-else>{{ dk ? dk : "-" }}</p>
              </div>
            </el-col>
          </template>
        </el-row>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { titleCase } from "@/lib/utils";

export default {
  name: "Verification",
  props: {
    identityType: {
      type: String,
      default: "Identity"
    },
    show: {
      type: Boolean,
      default: true
    },
    verification: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    dataHeaders() {
      return Object.keys(this.verification);
    },

    shouldShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      }
    }
  },

  methods: {
    closeEvent() {
      this.shouldShow = false;
    },

    titleize(key) {
      return titleCase(key);
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  color: #140508;
  font-weight: 500;
}

p {
  font-size: 0.875rem;
  margin-bottom: 5px;
}

span {
  font-size: 0.875rem;
  font-weight: 500;
  color: #140508;
}

.el-tag {
  font-size: 0.75rem;
}

.data-headers {
  padding: 10px 40px;
  height: 600px;
  overflow-y: scroll;

  .data-min-header {
    margin-bottom: 5px;
  }

  .data-header {
    margin-bottom: 30px;
  }

  .data-min-header,
  .data-header {
    h6 {
      margin-bottom: 15px;
      color: #9e1531;
    }

    &--content {
      background: #57645e10;
      border-radius: 8px;
      padding: 10px;
      margin-bottom: 10px;

      span {
        font-size: 13px;
        font-weight: 400;
      }

      p {
        font-size: 1rem;
        font-weight: 600;
      }
    }

    &--image__image {
      height: 120px;
      width: 120px;
      margin: 0 auto;
      border-radius: 1000px;
      background: #798b8350;
      overflow: hidden;

      img {
        height: 100%;
        width: 100%;
        object-fit: contain;
      }
    }

    &--image__signature {
      height: 80px;
      width: 200px;
      border-radius: 5px;

      img {
        height: 100%;
        width: 100%;
        object-fit: contain;
      }
    }
  }
}
</style>
